import {
  LicenceVersion,
  LICENCE_VERSIONS,
  LICENCE_VERSION_SAP,
} from "./Licence";

export type TagPolicy = {
  defaults?: {
    replicas?: number;
    migrations?: number;
  };
  enforced?: boolean;
};

export type LicensingPolicy = {
  allowed_tags?: string[];
  allowed_licence_types?: Array<"fixed" | "floating">;
  allowed_licence_versions?: LicenceVersion[];
  tag_policies?: Record<string, TagPolicy>;
};

/** Whether the partner is one of the few allowed to issue SAP licences. */
export const isSapAllowedByPolicy = (
  policy: LicensingPolicy | null | undefined,
): boolean =>
  policy?.allowed_licence_versions?.includes(LICENCE_VERSION_SAP) ?? false;

/** The licence editions the partner may pick from, in display order. */
export const getAllowedLicenceVersions = (
  policy: LicensingPolicy | null | undefined,
): LicenceVersion[] =>
  LICENCE_VERSIONS.filter(
    version => version !== LICENCE_VERSION_SAP || isSapAllowedByPolicy(policy),
  );
